export default "__VITE_ASSET__EL0X6ZFO__"